import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  getProductArticle,
  getBrandName,
  getFirstGalleryImageThumbUrl,
  getSeoMetaDescription,
} from 'store/ProductDetails/selectors';

export function SchemaProductContainerLayout({ brand, thumbUrl, article, description, children }) {
  return (
    <div itemScope itemType="http://schema.org/Product">
      {children}
      <div itemProp="brand" itemType="https://schema.org/Brand" itemScope>
        <meta itemProp="name" content={brand} />
      </div>
      <meta itemProp="image" content={thumbUrl} />
      <meta itemProp="sku" content={article} />
      <meta itemProp="mpn" content={article} />
      <meta itemProp="description" content={description} />
    </div>
  );
}

SchemaProductContainerLayout.propTypes = {
  brand: PropTypes.string,
  thumbUrl: PropTypes.string,
  article: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.any,
};

const mapStateToProps = (state) => ({
  brand: getBrandName(state),
  thumbUrl: getFirstGalleryImageThumbUrl(state),
  article: getProductArticle(state),
  description: getSeoMetaDescription(state),
});

const SchemaProductContainer = connect(mapStateToProps)(SchemaProductContainerLayout);
export default SchemaProductContainer;
